import { Formik } from 'formik'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { InviteMC } from 'src/constants/actionTypes'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { InviteMCViaMessageFormValues } from './InviteMCViaMessageForm.interface'
import { InviteMCViaMessageSchema } from './InviteMCViaMessageForm.validator'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import tw from 'twin.macro'
import { showToast } from 'src/utils/toast'
import { Button } from 'src/components/shared/Button'
import { handleApiError } from 'src/utils/errorHandlers'

const initialValues: InviteMCViaMessageFormValues = {
  firstName: '',
  lastName: '',
  companyName: '',
  email: '',
}

interface Props {
  onSubmit(): void
  onClose(): void
}

export const InviteMCViaMessageForm = ({ onSubmit, onClose }: Props) => {
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleFormSubmit = async (values: InviteMCViaMessageFormValues) => {
    setIsLoading(true)

    try {
      await createAsyncAction(dispatch, InviteMC.request(values))

      showToast('Invite is sent!')

      onSubmit()
      onClose()
    } catch (err: any) {
      handleApiError(err)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleFormSubmit}
      validationSchema={InviteMCViaMessageSchema}
    >
      {({ handleSubmit }) => (
        <div>
          <div css={tw`px-4 pt-4`}>
            <div css={tw`grid grid-cols-2 gap-4 mb-4 pb-4`}>
              <FormikTextField
                name="firstName"
                css={tw`w-[240px]`}
                label="First name"
                placeholder="Enter contractor's first name"
                inputProps={{ 'data-testid': 'mc-onboarding-invite-mc-first-name-input' }}
              />
              <FormikTextField
                name="lastName"
                label="Last name"
                css={tw`w-[240px]`}
                placeholder="Enter contractor's last name"
                inputProps={{ 'data-testid': 'mc-onboarding-invite-mc-last-name-input' }}
              />
              <FormikTextField
                name="companyName"
                label="Company name"
                css={tw`w-[240px]`}
                placeholder="Enter company name"
                inputProps={{ 'data-testid': 'mc-onboarding-invite-mc-company-name-input' }}
              />
              <FormikTextField
                name="email"
                label="Email"
                css={tw`w-[240px]`}
                placeholder="Enter contractor's email"
                inputProps={{ 'data-testid': 'mc-onboarding-invite-mc-email-input' }}
              />
            </div>
          </div>
          <div
            css={tw`flex flex-col justify-end items-end border-0 border-t border-solid border-[#EDEDED] mt-4 p-4 pb-3 pt-3`}
          >
            <Button
              variant="contained"
              size="small"
              loading={isLoading}
              onClick={() => handleSubmit()}
              data-testid="mc-onboarding-invite-mc-send-invite-btn"
            >
              Send invite
            </Button>
          </div>
        </div>
      )}
    </Formik>
  )
}
